import {
  FILE_EXTENSION_CSV,
  FILE_EXTENSION_PDF,
  FILE_EXTENSION_SIF,
  FILE_EXTENSION_XLS,
  FILE_EXTENSION_XLSX,
  XLSX_REPORT_TYPES,
} from '../constants';

export const downloadExcelFile = async (path, name = 'excel', event = null) => {
  try {
    const response = await fetch(path);
    const blob = await response.blob();
    let fileExtension = FILE_EXTENSION_XLS;
    if (path.includes(FILE_EXTENSION_CSV)) {
      fileExtension = FILE_EXTENSION_CSV;
    }
    if (path.includes(FILE_EXTENSION_SIF)) {
      fileExtension = FILE_EXTENSION_SIF;
    }
    if (path.includes(FILE_EXTENSION_PDF)) {
      fileExtension = FILE_EXTENSION_PDF;
    }
    
    if (XLSX_REPORT_TYPES.includes(name) && path.includes(FILE_EXTENSION_XLSX)) {
      fileExtension = FILE_EXTENSION_XLSX;
    }

    const downloadLink = document.createElement('a');
    downloadLink.href = window.URL.createObjectURL(blob);
    const id = extractFileId(path);

    downloadLink.download = ['PayrollReport'].includes(event)
      ? `${id}.${fileExtension}`
      : `${name}_${new Date().getTime()}.${fileExtension}`;
    downloadLink.click();
    window.URL.revokeObjectURL(downloadLink.href);
  } catch (error) {
    console.error('Error downloading Excel file', error);
  }
};
const extractFileId = (path) => {
  if (!path) return null;

  const cleanPath = path.split('?')[0];
  const match = cleanPath.match(/\/exports\/([^/.]+)\./);

  return match ? match[1] : null;
};


export const downloadPdfFile = async (path, name = 'download') => {
  try {
    const response = await fetch(path);
    const blob = await response.blob();

    const downloadLink = document.createElement('a');
    downloadLink.href = window.URL.createObjectURL(blob);
    downloadLink.download = `${name}_${new Date().getTime()}.pdf`;
    downloadLink.click();
    window.URL.revokeObjectURL(downloadLink.href);
  } catch (error) {
    console.error('Error downloading Excel file', error);
  }
};

export const showFile = async (url) => {
  const showLink = document.createElement('a');
  showLink.href = url;
  showLink.setAttribute('target', '_blank');
  showLink.click();
};
